import React from 'react'
import Link from 'gatsby-link'
import moment from 'moment'

function getIconForType(type) {
  if (type === 'PLACE') {
    return 'fa-map-marker'
  } else if (type === 'FLIGHT') {
    return 'fa-plane'
  } else if (type === 'TRAIN') {
    return 'fa-train'
  }

  return 'fa-globe-americas'
}

const Timeline = ({ data, now }) => (
  <div className="steps is-small">
    {data.map(leg => {
      const start = moment(leg.start)
      const end = moment(leg.end)

      const markerModifierClass =
        now.isAfter(start) && now.isBefore(end) ? 'is-active' : ''
      const itemModifierClass = now.isAfter(end)
        ? 'is-completed'
        : 'is-completed is-info'
      const iconModifierClass = getIconForType(leg.type)

      const linkLocation =
        leg.type === 'PLACE'
          ? `https://travel.sethcorker.me/tags/${leg.tag.toLowerCase()}/`
          : '#'

      return (
        <div
          className={`step-item ${itemModifierClass}`}
          title={`From ${start.format('ha dddd')} to ${end.format('ha dddd')}`}
        >
          <a href={linkLocation} key={`${start}-${end}`}>
            <div className={`step-marker ${markerModifierClass}`}>
              <span className="icon">
                <i className={`fas ${iconModifierClass}`} />
              </span>
            </div>
            <div className="step-details">
              <p className="step-title">{leg.name}</p>
            </div>
          </a>
        </div>
      )
    })}
  </div>
)

export default Timeline



// WEBPACK FOOTER //
// ./src/components/timeline.js